import PermissionsMatrix from 'views/PermissionMatrix';

export default [
  {
    key: 'show',
    component: PermissionsMatrix,
    path: '/permission-matrix',
    public: false,
  },
];